import { useIntl } from 'react-intl';
import { useCallback } from 'react';
import { getNumberOfDigits } from '../getNumberOfDigits';

export const useFormatCurrencyCallback = () => {
    const intl = useIntl();

    return useCallback(
        (amount: number, currency: string) => {
            const digits = getNumberOfDigits(amount);

            return intl.formatNumber(amount, {
                style: 'currency',
                currency,
                minimumFractionDigits: digits,
                maximumFractionDigits: digits,
            });
        },
        [intl],
    );
};
